import { createContext } from 'react';

export interface RefreshShortcutContextValue {
  registerRefresh: (scope: string, callback: () => void) => void;
  unregisterRefresh: (scope: string) => void;
  setActiveScope: (scope: string | null) => void;
}

export const RefreshShortcutContext = createContext<RefreshShortcutContextValue | null>(null);
